// Copyright (c) 2015, salesforce.com, inc. All rights reserved.

import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'

import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome'
import { faHandHoldingUsd } from '@fortawesome/free-solid-svg-icons'

import {
  ProductCard,
  SpanWithData,
  DisplayAmount,
  NavLink
} from '../'


export class WithdrawalCard extends React.PureComponent {
  static propTypes = {
    withdrawalId: PropTypes.string.isRequired,
    amountRequested: PropTypes.number,
    amountType: PropTypes.string,
    feeAmount: PropTypes.number,
    initiateOn: PropTypes.string,
    status: PropTypes.string,
    withdrawalAmount: PropTypes.number,
    feePayment: PropTypes.object,
    sellTransaction: PropTypes.object,
    targetName: PropTypes.string,
    withdrawalBatch: PropTypes.object,
    withdrawalPayment: PropTypes.object,
    detailLink: PropTypes.string,
    onDetailLinkClick: PropTypes.func,
    detailView: PropTypes.bool,
    className: PropTypes.string
  }

  static defaultProps = {
    className: ''
  }

  render() {
    let {
      withdrawalId,
      amountRequested,
      amountType,
      feeAmount,
      initiateOn,
      status,
      withdrawalAmount,
      feePayment,
      sellTransaction,
      sourceName,
      targetName,
      withdrawalBatch,
      withdrawalPayment
    } = this.props

    let secondaryDetails = this.props.detailView
      ? {
          'Withdraw from': sourceName,
          'Towards': targetName,
          'Initiate on': initiateOn
            ? moment(initiateOn).format("D MMM 'YY")
            : '-',
          'Withdrawal amount': <DisplayAmount amountString={withdrawalAmount} />,
          'Fee': <DisplayAmount amountString={feeAmount} />,
          'Status': <SpanWithData
              forField='WithdrawalStatus'
              searchKey={status}
            />,
          'Batch': withdrawalBatch
            ? <NavLink to={`/os/products/withdrawalbatches/${withdrawalBatch.id}`}>
                <SpanWithData
                  forField='WithdrawalBatchStatus'
                  searchKey={withdrawalBatch.status}
                />
                {withdrawalBatch.initiateOn &&
                  `(${moment(withdrawalBatch.initiateOn).format("D MMM 'YY")})`
                }
              </NavLink>
            : '-',
          'Transaction': sellTransaction
            ? <NavLink to={`/os/operations/finance/transactions/${sellTransaction.id}`}>
                {sellTransaction
                  ? sellTransaction.name
                  : '-'
                }
              </NavLink>
            : '-',
          'Fee payment': feePayment
            ? <NavLink to={`/os/operations/finance/payments/${feePayment.id}`}>
                <DisplayAmount amountString={feePayment.amount} />
              </NavLink>
            : '-',
          'Withdrawal payment': withdrawalPayment
            ? <NavLink to={`/os/operations/finance/payments/${withdrawalPayment.id}`}>
                <DisplayAmount amountString={withdrawalPayment.amount} />
              </NavLink>
            : '-'
        }
      : {
          'Withdraw from': sourceName,
          'Towards': targetName,
          'Withdrawal amount': <DisplayAmount amountString={withdrawalAmount} />,
          'Fee': <DisplayAmount amountString={feeAmount} />,
          'Initiate on': initiateOn
            ? moment(initiateOn).format("D MMM 'YY")
            : '-',
          'Status': <SpanWithData
              forField='WithdrawalStatus'
              searchKey={status}
            />,
          'Batch': <NavLink to={`/os/products/withdrawalbatches/${withdrawalBatch.id}`}>
              <SpanWithData
                forField='WithdrawalBatchStatus'
                searchKey={withdrawalBatch.status}
              />
              {withdrawalBatch.initiateOn &&
                `(${moment(withdrawalBatch.initiateOn).format("D MMM 'YY")})`
              }
            </NavLink>
        }

    return (
      <ProductCard
        title='Withdrawal'
        subtitle={{
          'Requested amount': amountType === 'FIXED'
            ? <DisplayAmount amountString={amountRequested} />
            : `${parseInt(amountRequested, 10)}%`,
          'Amount type': <SpanWithData
            forField='WithdrawalAmountType'
            searchKey={amountType}
          />
        }}
        iconOverride={
          <Icon
            icon={faHandHoldingUsd}
            size='4x'
            className='slds-text-color_weak'
          />
        }
        secondaryDetails={secondaryDetails}
        footerText='Detail and history'
        footerLink={this.props.detailLink}
        onFooterLinkClick={() => this.props.onDetailLinkClick(withdrawalId)}
        hideFooter={this.props.detailView}
        backgroundColour={null}
        footerBackgroundColour={null}
        className={`u-bg-color-white ${this.props.className}`}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/withdrawal-card/index.js